import FeaturesGrid from './features-grid';

export default function FeaturesPage() {
  return <FeaturesGrid />;
}
